import { Utility } from '../utility/utility_controller'

var outsideOverlayCloseResizeTicking = false
var resizeSyncBound = false
var pageOverlayCloseRevealTimers = {}

function getDetachedCloseEl(id) {
	if (!id) return null
	return document.querySelector('.overlay-close-id-' + id + '[data-lay-close-detached="on"]')
}

function getOverlayCloseOutsideDistance(closeEl) {
	var attr = Utility.isPhoneSize ? closeEl.getAttribute('data-lay-close-outside-distance-phone') : closeEl.getAttribute('data-lay-close-outside-distance')
	var distance = parseFloat(attr)
	return isNaN(distance) ? 0 : distance
}

function syncOutsideOverlayClose($overlay) {
	if (!$overlay || !$overlay.length) return

	var overlayEl = $overlay[0]
	var id = overlayEl.getAttribute('data-id')
	if (!id || !$overlay.hasClass('display-block-overlay')) return

	var closeEl = getDetachedCloseEl(id)
	if (!closeEl) return

	var overlayRect = overlayEl.getBoundingClientRect()
	var closeRect = closeEl.getBoundingClientRect()
	var closeWidth = closeRect.width
	var closeHeight = closeRect.height
	if (!closeWidth || !closeHeight) return

	var position = closeEl.getAttribute('data-lay-close-outside-position') || 'top-right'
	var distance = getOverlayCloseOutsideDistance(closeEl)
	var top = overlayRect.top - distance - closeHeight
	var left = overlayRect.right - closeWidth

	switch (position) {
		case 'top-left':
			left = overlayRect.left
			break
		case 'top-center':
			left = overlayRect.left + overlayRect.width / 2 - closeWidth / 2
			break
		case 'right-top':
			top = overlayRect.top
			left = overlayRect.right + distance
			break
		case 'right-center':
			top = overlayRect.top + overlayRect.height / 2 - closeHeight / 2
			left = overlayRect.right + distance
			break
		case 'right-bottom':
			top = overlayRect.bottom - closeHeight
			left = overlayRect.right + distance
			break
		case 'bottom-right':
			top = overlayRect.bottom + distance
			left = overlayRect.right - closeWidth
			break
		case 'bottom-center':
			top = overlayRect.bottom + distance
			left = overlayRect.left + overlayRect.width / 2 - closeWidth / 2
			break
		case 'bottom-left':
			top = overlayRect.bottom + distance
			left = overlayRect.left
			break
		case 'left-bottom':
			top = overlayRect.bottom - closeHeight
			left = overlayRect.left - distance - closeWidth
			break
		case 'left-center':
			top = overlayRect.top + overlayRect.height / 2 - closeHeight / 2
			left = overlayRect.left - distance - closeWidth
			break
		case 'left-top':
			top = overlayRect.top
			left = overlayRect.left - distance - closeWidth
			break
	}

	closeEl.style.position = 'fixed'
	closeEl.style.top = Math.round(top) + 'px'
	closeEl.style.left = Math.round(left) + 'px'
	closeEl.style.right = 'auto'
	closeEl.style.bottom = 'auto'
	closeEl.style.transform = 'none'
}

function reveal($overlay) {
	if (!$overlay || !$overlay.length) return

	$overlay.each(function () {
		var id = this.getAttribute('data-id')
		if (!id) return
		var closeEl = getDetachedCloseEl(id)
		if (!closeEl) return
		syncOutsideOverlayClose(jQuery(this))
		closeEl.style.removeProperty('visibility')
		closeEl.classList.add('lay-page-overlay-close-is-visible')
	})
}

function hide($overlay) {
	if (!$overlay || !$overlay.length) {
		jQuery('.overlay-close[data-lay-close-detached="on"]').removeClass('lay-page-overlay-close-is-visible').css('visibility', '')
		return
	}

	$overlay.each(function () {
		var id = this.getAttribute('data-id')
		if (!id) return
		var closeEl = getDetachedCloseEl(id)
		if (closeEl) {
			closeEl.classList.remove('lay-page-overlay-close-is-visible')
			closeEl.style.removeProperty('visibility')
		}
	})
}

function syncOutside($overlays) {
	var $targets = $overlays && $overlays.length ? $overlays : jQuery('.lay-overlay.display-block-overlay')
	$targets.each(function () {
		syncOutsideOverlayClose(jQuery(this))
	})
}

function syncOutsideForDuration($overlay, duration) {
	if (typeof duration == 'undefined') {
		duration = getSyncDuration($overlay)
	}
	var start = Date.now()
	var tick = function () {
		syncOutside($overlay)
		if (Date.now() - start < duration && (!$overlay || $overlay.hasClass('display-block-overlay'))) {
			window.requestAnimationFrame(tick)
		}
	}
	window.requestAnimationFrame(tick)
}

function getSyncDuration($overlay) {
	var duration = 1000
	if (!$overlay || !$overlay.length) return duration

	$overlay.each(function () {
		var id = this.getAttribute('data-id')
		if (!getDetachedCloseEl(id)) return
		duration = Math.max(duration, getRevealDelay(this) + 200)
	})
	return duration
}

function getCssTimeInMs(value) {
	if (!value) return 0
	var parts = String(value).split(',')
	var max = 0
	for (var i = 0; i < parts.length; i++) {
		var part = parts[i].trim()
		if (!part) continue
		var number = parseFloat(part)
		if (isNaN(number)) continue
		var ms = part.indexOf('ms') > -1 ? number : number * 1000
		if (ms > max) max = ms
	}
	return max
}

function openAnimationIsNone(overlayEl) {
	var noneDesktopClasses = ['lay-none', 'lay-none-top', 'lay-none-left', 'lay-none-right', 'lay-none-bottom']
	var nonePhoneClasses = ['lay-phone-none', 'lay-phone-none-top', 'lay-phone-none-left', 'lay-phone-none-right', 'lay-phone-none-bottom']
	var classes = Utility.isPhoneSize ? nonePhoneClasses : noneDesktopClasses
	for (var i = 0; i < classes.length; i++) {
		if (overlayEl.classList.contains(classes[i])) return true
	}
	return false
}

function getRevealDelay(overlayEl) {
	if (openAnimationIsNone(overlayEl)) return 0

	var style = window.getComputedStyle(overlayEl)
	var cssVarDuration = getCssTimeInMs(style.getPropertyValue('--lay-overlay-animation-duration'))
	if (cssVarDuration > 0) {
		return cssVarDuration + 80
	}

	return Math.max(
		getCssTimeInMs(style.transitionDuration) + getCssTimeInMs(style.transitionDelay),
		getCssTimeInMs(style.animationDuration) + getCssTimeInMs(style.animationDelay)
	) + 80
}

function clearRevealTimer(id) {
	if (!id || !pageOverlayCloseRevealTimers[id]) return
	clearTimeout(pageOverlayCloseRevealTimers[id])
	delete pageOverlayCloseRevealTimers[id]
}

function scheduleReveal($overlay) {
	if (!$overlay || !$overlay.length) return

	hide($overlay)
	$overlay.each(function () {
		var id = this.getAttribute('data-id')
		if (!id) return
		if (!getDetachedCloseEl(id)) return
		clearRevealTimer(id)

		var revealOverlay = function () {
			delete pageOverlayCloseRevealTimers[id]
			reveal(jQuery(this))
		}.bind(this)
		var delay = getRevealDelay(this)

		if (delay <= 0) {
			window.requestAnimationFrame(revealOverlay)
			return
		}
		pageOverlayCloseRevealTimers[id] = setTimeout(revealOverlay, delay)
	})
}

function revealAfterAnimation($overlay) {
	if (!$overlay || !$overlay.length) return

	$overlay.each(function () {
		var id = this.getAttribute('data-id')
		if (!getDetachedCloseEl(id)) return
		if (id && pageOverlayCloseRevealTimers[id]) return
		reveal(jQuery(this))
	})
}

function clearRevealTimers($overlay) {
	if (!$overlay || !$overlay.length) {
		Object.keys(pageOverlayCloseRevealTimers).forEach(clearRevealTimer)
		return
	}
	$overlay.each(function () {
		clearRevealTimer(this.getAttribute('data-id'))
	})
}

function requestOutsideSync() {
	if (outsideOverlayCloseResizeTicking) return
	outsideOverlayCloseResizeTicking = true
	window.requestAnimationFrame(function () {
		outsideOverlayCloseResizeTicking = false
		syncOutside()
	})
}

function bindResizeSync() {
	if (resizeSyncBound) return
	resizeSyncBound = true
	jQuery(window).on('resize orientationchange scroll', requestOutsideSync)
}

var page_overlay_close_controller = {
	bindResizeSync: bindResizeSync,
	clearRevealTimers: clearRevealTimers,
	hide: hide,
	revealAfterAnimation: revealAfterAnimation,
	scheduleReveal: scheduleReveal,
	syncOutside: syncOutside,
	syncOutsideForDuration: syncOutsideForDuration,
}

export default page_overlay_close_controller
